import Component from './terms'

export default Component